"use strict";

angular.module("core")
.controller("MaintenanceController", function($scope, $state) {
    this.tryAgain = function() {
        $state.go("home");
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/http-error-response/maintenance.controller.js
// module id = 406
// module chunks = 0